export const PRIVATE_API_TOKEN_PREFIX = "prvt_";
export const DEV_PARTNER_API_TOKEN_PREFIX = "dev_";
export const ADMIN_API_TOKEN_PREFIX = "tnb_";

export const isPrivateApiToken = (token: string) =>
  token.startsWith(PRIVATE_API_TOKEN_PREFIX);

export const isDevPartnerApiToken = (token: string) =>
  token.startsWith(DEV_PARTNER_API_TOKEN_PREFIX);

export const isAdminApiToken = (token: string) =>
  token.startsWith(ADMIN_API_TOKEN_PREFIX);

export const isUserScopedApiToken = (token: string) =>
  isPrivateApiToken(token) || isAdminApiToken(token);

export const getDeveloperZoneEndpoint = (token: string) => {
  const baseUrl = import.meta.env.VITE_API_SERVER_URL;
  if (isAdminApiToken(token)) return `${baseUrl}/graphql/admin`;
  if (isPrivateApiToken(token)) return `${baseUrl}/graphql`;
  return `${baseUrl}/graphql/dev-partner`;
};
